"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_redux_1 = require("react-redux");
const roomCreateStore_1 = require("@/room/room_create/roomCreateStore");
const react_i18next_1 = require("react-i18next");
const svgs_1 = require("@@/assets/svgs");
const components_1 = require("@/common/components");
const functions_1 = require("@/common/functions");
const useMediaQuery_1 = __importDefault(require("@mui/material/useMediaQuery"));
const IconButton_1 = __importDefault(require("@mui/material/IconButton"));
const second_step_1 = require("./second_step");
function default_1() {
    const roomCreateStep = (0, react_redux_1.useSelector)((state) => state.roomCreateStep);
    const isFirstStep = roomCreateStep === '1';
    const isSecondStep = roomCreateStep === '2';
    const isPreview = roomCreateStep === 'preview';
    const isCloneRoom = (0, react_redux_1.useSelector)((state) => Boolean(state.roomData.original_room));
    const dispatch = (0, react_redux_1.useDispatch)();
    const onHeaderBackClick = () => {
        if (isFirstStep)
            (0, functions_1.goBackOrMain)();
        else if (isSecondStep)
            dispatch((0, roomCreateStore_1.setRoomCreateStep)('1'));
        else if (isPreview)
            dispatch((0, roomCreateStore_1.setRoomCreateStep)('2'));
    };
    const { t } = (0, react_i18next_1.useTranslation)();
    const maxWidth768 = (0, useMediaQuery_1.default)('(max-width:768px)');
    const isSecondStepPCView = isSecondStep && !maxWidth768;
    if (isSecondStepPCView)
        return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
    return ((0, jsx_runtime_1.jsxs)(components_1.SubHeaderGrid, { children: [(0, jsx_runtime_1.jsx)(IconButton_1.default, Object.assign({ onClick: onHeaderBackClick }, { children: isFirstStep ? (0, jsx_runtime_1.jsx)(svgs_1.HeaderCloseSvg, {}) : (0, jsx_runtime_1.jsx)(svgs_1.HeaderBackSvg, {}) })), isFirstStep ? ((0, jsx_runtime_1.jsx)("span", { children: t('판매 시작') })) : isSecondStep ? ((0, jsx_runtime_1.jsx)("span", { children: t('폼 만들기') })) : isPreview ? ((0, jsx_runtime_1.jsx)("span", { children: t('미리 보기') })) : ((0, jsx_runtime_1.jsx)("span", {})), isSecondStep && !isCloneRoom && (0, jsx_runtime_1.jsx)(second_step_1.TempSaveButton, {})] }));
}
exports.default = default_1;
